// @flow
import * as React from 'react';
import type {FileComponents, Toggles} from 'docs/data/integration-builder';

const getFilename = (file: React.Element<any>): string => {
  return file.props.children.props.children.props.filename || '';
};

const isVisible = (file: React.Element<any>, toggles: Toggles): boolean => {
  const when = file.props.children.props.children.props.when;

  if (when && when.toggle) {
    return toggles[when.toggle];
  }

  return true;
};

export const loadFiles = (
  path: string,
  toggles: Toggles,
  children: Array<React.Element<any>>,
): FileComponents => {
  const components = {};
  children.forEach((child) => {
    if (
      child?.props?.file?.includes(`files/${path}`) &&
      isVisible(child, toggles)
    ) {
      const filename = getFilename(child);
      components[filename] = child;
    }
  });
  return components;
};
